import GotQuestions from "./GotQuestions";

export default GotQuestions;
